const staffData = [
    {
        id: 1,
        staffname: 'Victoria Nguyen',
        description: "Victoria is a Certified Massage Therapist and Cosmetologist. An alumnus of the National Holistic Institute in Sacramento, she graduated with honors and received excellence accolades. In the realm of cosmetology, Victoria brings a keen eye for beauty and detail, ensuring her clients feel both relaxed and revitalized. She offers a tailored, safe, and exceptional therapeutic massage experience with utmost professionalism.",
        img: require('../../img/Staff/stafftwo.jpg')
    },
    {
        id: 2,
        staffname: 'Susan Yu Lin',
        description: "Susan Yu Lin is a dedicated therapist with over 10 years of professional experience. Known for her genuine warmth and friendly approach, she consistently goes above and beyond to ensure her clients feel comfortable and valued. Susan's expertise, combined with her compassionate nature, has positively influenced countless lives, making her a sought-after therapist in her community",
        img: require('../../img/Staff/staff3.jpg')
    },
    {
        id: 3,
        staffname: 'Amy Zheng',
        description: "Amy Zheng excels as a Chinese massage therapist, combining professionalism with a friendly demeanor. Her expertise enables her to deliver a 60-minute massage session that feels as comprehensive and rejuvenating as a typical 90-minute session elsewhere. Amy's approach is not only professional but also charming and artistic, making her an exceptional therapist in her field",
        img: require('../../img/Staff/right.jpg')
    },
];

export default staffData;
